<template>
  <v-tabs dark :scrollable="false" v-model="selected_tab" :color="$dark() ? 'grey darken-4' : 'deep-orange'" slider-color="yellow" class="bottom-sheet-tabs">
    <v-tab v-for="tab in filtered_tabs" :key="tab.href" :href="'#'+tab.name" :disabled="isDisabled(tab)">{{ tab.title }}</v-tab>
    <v-spacer></v-spacer>
    <v-btn v-if="$is_admin()" icon @click="toggleFullscreen"><v-icon v-if="$root.bottomSheetFullscreen">fullscreen_exit</v-icon><v-icon v-else>fullscreen</v-icon></v-btn>
    <v-tab href="#__close_editor__"><v-icon>close</v-icon></v-tab>

    <v-tab-item v-for="tab in filtered_tabs" :key="tab.name" :value="tab.name">
      <v-card tile flat class="bottom-sheet-tab-card">
        <component :is="tab.component" :id="id" :data="data"></component>
      </v-card>
    </v-tab-item>
  </v-tabs>
</template>

<script>
import Vue from 'vue'

export default {
  props: {
    id: {
      default: undefined
    },
    data: {
      default: undefined
    },
    tabs: {
      type: Array,
      default: [],
      required: true
    },
    'default-tab': String
  },
  computed: {
    filtered_tabs () {
      return this.tabs.filter(tab => {
        return (tab.admin_only && this.$is_admin()) || !tab.admin_only;
      });
    },
    selected_tab: {
      get() {
        return this.$route.query.tab || this.defaultTab;
      },
      set (val) {

        if(val == "__close_editor__") {
          this.$root.close_bottom_sheet();
        } else {
          this.$router.push({query: {...this.$route.query, tab: val}})
        }
      }
    },
  },
  methods: {
    toggleFullscreen() {
      this.$root.fullscreen_bottom_sheet();
    },
    isDisabled (tab) {
      if(tab.edit_only && typeof(this.id) == "undefined") return true;
      if(tab.new_only && typeof(this.id) != "undefined") return true;
      return false;
    }
  }
}
</script>

<style>
.el-form-item .info {
  line-height: 16px;
  font-size: 12px;
  color: #777;
}
</style>
